import styled from '@emotion/styled';
import { FunctionComponent } from 'react';
import Select, { GroupBase, StylesConfig } from 'react-select';

import { PaletteColor, Size } from '../../styling/AppStyles';

export type ExinSelectOption = {
  value: string;
  label: string;
};

/**
 * Define some style overrides for `react-styles`. Exported so that <ExinAsyncSelect> can use them
 * too.
 *
 * Docs:
 *   https://react-select.com/styles
 */
export const reactSelectStyleOverrides: StylesConfig<unknown, boolean, GroupBase<unknown>> = {
  control: (defaultStyle) => ({
    ...defaultStyle,
    border: 'none',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (defaultStyle) => ({
    ...defaultStyle,
    color: PaletteColor.text,
  }),
};

/**
 * A react-select <Select> with custom styles
 */
const ExinSelectInner = styled(Select)<{ spaceBelow?: boolean }>`
  font-family: Roboto, sans-serif;
  font-size: 0.875em;
  ${({ spaceBelow }) => (spaceBelow ? `margin-bottom: ${Size.smaller}` : null)};
  @media (min-width: 600px) {
    font-size: 1em;
  }
`;

const ExinSelect: FunctionComponent<
  typeof Select extends FunctionComponent<infer P> ? P : unknown
> = (props) => <ExinSelectInner {...props} styles={reactSelectStyleOverrides} />;

export default ExinSelect;
